import theme from 'styled-theming';
var getModalBackground = theme('mode', {
  light: 'var(--white)',
  dark: 'var(--dark-tempColor)'
});
var getModalTitleColor = theme('mode', {
  light: 'var(--charcoal)',
  dark: 'var(--dark-tempColor)'
});
var getModalWarningColor = theme('mode', {
  light: 'var(--lightRed)',
  dark: 'var(--dark-tempColor)'
});
export default {
  getModalBackground: getModalBackground,
  getModalTitleColor: getModalTitleColor,
  getModalWarningColor: getModalWarningColor
};